import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'booleanName' })
export class BooleanNamePipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? '是' : '否';
  }
}
